import React, { useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import { useLocation, useNavigate } from 'react-router-dom';
import senddata from "../../Data/data.js";
import sendFormData from "../../Data/formData.js";

function ExamInVideo() {

  const location = useLocation();
  const navigate = useNavigate()

  var state = location.state;

  const videoId = localStorage.getItem("videoid_for_video_exam")
  const courseId = localStorage.getItem("courseid_for_video_exam")
  const videoName = localStorage.getItem("videoname_for_video_exam")

  const [subject,setSubject] = useState("chemstiry");
  const [title,setTitle] = useState("");
  const [describtion,setDescribtion] = useState("");
  const [level,setLevel] = useState("one");
  const [department,setDepartment] = useState("sec");
  const [selected_ids,setSelected_ids] = useState(state?.selectedIds||[]);
  const [questions,setQuestions] = useState([]);
  
  const [selectedquestions,setSelectedQuestions] = useState(state?.selectedq||[]);

  const addExam = ()=>{
    const data = new FormData();
    data.append('subject', subject);
    data.append('title', title);
    data.append('describtion', describtion);
    data.append('level', level);
    data.append('department', department);
    data.append('questions', JSON.stringify(questions)); 
    data.append('selected_ids', JSON.stringify(selected_ids)); 

    if(subject&&describtion&&level&&department&&selected_ids.length > 0 ){
      
    sendFormData(`teacher/exam/add_exercies_in_video/${courseId}/${videoId}`,data, "POST").then((res) => {
      if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
      } else {
        alert("تم اضافة الامتحان بنجاح")
        navigate("/paging")
      }
    });
    }else{
      alert("ادخل كل البيانات")
    }
  }

  const addQuestions = ()=>{
    navigate("/choosefromQuestionBank",{state:{level,selectedquestions,selected_ids,examtype:"examinvideo"}})
  }

  const deleteQuestion = (id)=>{
    setSelected_ids((prevIds) => prevIds.filter(qId => qId !== id));
    setSelectedQuestions((prevQuestions) => prevQuestions.filter(q => q._id !== id));
  }

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
          <div className='headers  '>
              <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
          </div>
          <div className='add_student p-5 w-screen text-right flex flex-col justify-end '>
            <div className='flex flex-col items-center'>
                <h2 className='border-b-2 border-[#e9ad03] pb-1 w-fit mb-4'> امتحان لفيديو {videoName}</h2>
            </div>
            <div>
              {/* form */}
              <div>
              {/* <div className=' grid grid-cols-2 rever gap-4'>
                  <label 
                    type="datetime-local"
                    value={start}
                    onChange={(e) => setStart(e.target.value)}
                    className="bg-transparent p-2 text-right "
                    > النهاية</label>
                  <label 
                    type="datetime-local"
                    value={start}
                    onChange={(e) => setStart(e.target.value)}
                    className="bg-transparent p-2 text-right "
                    > البداية</label>
                </div> */}
                <div className=' grid grid-cols-1 rever gap-4'>
                  <input 
                    type="text"
                    value={describtion}
                    onChange={(e) => setDescribtion(e.target.value)}
                    placeholder='عنوان الامتحان'
                    className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right w-full max-w-[600px] ml-auto "
                    />
                </div>
                {/* <div className='mt-4' >
                  <select value={level} onChange={(event)=>{setLevel(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                    <option value="one" className=' text-black'>اولي ثانوي</option>
                    <option value="two" className=' text-black'>تانية ثانوي</option>
                    <option value="three" className=' text-black'>تالتة ثانوي</option>
                  </select>
                </div> */}
              </div>
              {/* display quesrions */}
              {selectedquestions&&<div>
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[90%] ml-[5%] mt-6 '>
            {
              selectedquestions?.map((question,key)=>{
                const id =question._id
                return(
                  <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                    {question.img!="empty" && <div className=' grid grid-cols-1 rever gap-4'>
                      <img src={question.img} className='w-full mb-2 ' />
                    </div>}
                    <div className='p-3'>

                    <p className=' text-center text-[#e9ad03]'>{"السؤال"+" " +key} </p>
                        <p dir='rtl' > 👈 {question.question}</p>
                        {/* choice */}
                        {question.role=="choice"&&<p className=' text-center text-[#e9ad03]'>الاختيارات</p>}
                        {question.role=="choice"&&<>
                        <p className='mr-4' dir='rtl' >1- {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' >2- {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' >3- {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' >4- {question.answer_4}</p>
                        </>}
                        {/* correct */}
                        {question.role=="correct"&&<p className=' text-center text-[#e9ad03]'>الاجابة صحيحة</p>}
                        {question.role=="correct"&&<>
                        <p className='mr-4' dir='rtl' >{question.answer_1}</p>
                        </>}
                        {/* text */}
                        {question.role=="text"&&<p className=' text-center text-[#e9ad03]'>الاجابات المحتملة للقطعة</p>}
                        {question.role=="text"&&<>
                        <p className='mr-4' dir='rtl' > {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_4}</p>
                        </>}
                        {/* dialogue */}
                        {question.role=="dialogue"&&<p className=' text-center text-[#e9ad03]'>تكملة المحادثة</p>}
                        {
                          question.role=="dialogue" && question?.dialoguecompletionSpaces.length && question?.dialoguecompletionSpaces?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : </p>
                              <>
                                {item.length&&item?.map((answer)=>{
                                   return(<p className='mr-4' dir='rtl' > {answer} </p>)
                                })}
                              </>
                            </>
                          )
                          })
                        }
                        {/* complete */}
                        {question.role=="complete"&&<p className=' text-center text-[#e9ad03]'>التكملة الصحيحة</p>}
                        {
                          question.role=="complete" && question?.correctcomplete.length && question?.correctcomplete?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : {item} </p>
                            </>
                          )
                          })
                        }


                      <div className=' grid grid-cols-2 rever gap-4'>
                        {/* choice */}
                        {question.role=="choice"&&<p>{question.correctChoice=="answer_1"? "A":question.correctChoice=="answer_2"?"B":question.correctChoice=="answer_3"?"C":question.correctChoice=="answer_4"?"d":""} الاجابة الصحيحة</p>}
                        {/* bolean */}
                        {question.role=="boolean"&&<p>{question.correctBoolean=="answer_1"?"الاجابة صحيحة":"الاجابة خاطئة"}</p>}
                        <p>{question.mark} : الدرجة</p>
                      </div>
                      
                      <div className='flex justify-between items-center mt-4'>
                        <div className='flex '>
                        <p onClick={()=>{deleteQuestion(id)}} className='mr-4 text-lg cursor-pointer px-6 py-2 bg-[#eb0000] ml-auto w-fit rounded-full'>ازالة </p>
                        </div>
                        <p>{question.lec} : التصنيف </p>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
              </div>}

              {/* add */}
              <div className=' grid grid-cols-2 rever gap-4 mt-8'>
                <p onClick={addExam} className='px-6 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer'>اضافة الامتحان</p> 
                <p onClick={addQuestions} className='px-6 py-2 bg-[#e9ad03] ml-auto w-fit rounded-full cursor-pointer'>اضافة اسألة</p> 
              </div>
            </div>
          </div>
    </div>
  )
}

export default ExamInVideo
